
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Archery Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png" alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
            <div class="sec-title text-center">
                <h2>G H Raisoni Sports and Cultural Foundation Wraps Up a Thrilling <span>Memorial Archery Tournament, 2023 </span></h2>
            </div>

        <!-- <p>Nagpur| September 03: G H Raisoni Sports and Cultural Foundation in association with Nagpur Archery Association, is organising ‘G H Raisoni Memorial Archery Tournament, 2023’ on 3rd September, 2023, at 8:30 am on the G H Raisoni Institute of Engineering and Technology campus.</p>
       <p>G H Raisoni Memorial Archery Tournament is open to participant’s age-group Under 9, Under 11, Under 14, Under 17, and Under 19 and open. The tournament offers certificates, medals and making it an enticing and rewarding experience for the participating archers. The aim of the event is to promote sportsmanship skills among young talents in the field of archery.</p>
        <p>The organizers have meticulously planned the event to ensure adherence to all necessary safety protocols,ensuring a secure environment for all participants and attendees. The Archery Tournament 2023 promises to be a thrilling display of skill and precision as talented archers from various regions participate in the competition.</p>
        <p>To register click the link below :- <a href="https://forms.gle/Qq8V9yxdaqA7Gvyd8">https://forms.gle/Qq8V9yxdaqA7Gvyd8</a></p> -->
        <p class="text-justify">G H Raisoni Sports and Cultural Foundation, in
            collaboration with the Nagpur Archery
            Association, successfully concluded the G H Raisoni Memorial Archery
            Tournament, 2023
            on September 3, 2023, at the G H Raisoni Institute of Engineering
            and Technology campus.</p>
        <p class="text-justify">The tournament, which welcomed archers from
            various age groups, including Under 9, Under
            11, Under 14, Under 17, Under 19, and the open category, concluded
            with great excitement
            and success. Participants displayed remarkable skills, aiming for
            excellence and embodying
            the spirit of sportsmanship throughout the event.</p>
        <p class="text-justify">This archery extravaganza offered participants
            the opportunity to compete for certificates and
            medals, making it an enticing and rewarding experience for all
            archers involved. The
            tournaments primary objective was to foster sportsmanship skills
            among young talents in the
            field of archery, and it undoubtedly achieved that goal.</p>
        <p class="text-justify">The organizers meticulously planned and executed
            the event, ensuring strict adherence to all
            necessary safety protocols. The tournament witnessed breathtaking
            displays of skill and
            precision as archers from various regions competed fiercely for
            glory.</p>
        <p class="text-justify">The G H Raisoni Sports and Cultural Foundation
            extends its gratitude to all the participants,
            sponsors, and volunteers who contributed to the success of the G H
            Raisoni Memorial
            Archery Tournament, 2023.</p>

        <div class="sec-title text-center">
            <h4>Male <span >(Indian round) </span></h4>
        </div>
        <div class="row row-cols-1 row-cols-md-4">

            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 9:-</h6>
                <ul class="list-style list-style1">
                    <li>Shivam Dipak Bhitade (Gold)</li>
                    <li>Hasnain Samir Sheikh (Silver)</li>
                    <li>Viaan Shah (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 11:-</h6>
                <ul class="list-style list-style1">
                    <li>Parthamesh N Kohale (Gold)</li>
                    <li>Nimish Kesharwani (Silver)</li>
                    <li>Saksham Thakre (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 14:-</h6>
                <ul class="list-style list-style1">
                    <li>Rajnit Bharat Gomase (Gold)</li>
                    <li>Vinit Chandrakant dehalikar (Silver)</li>
                    <li>Anant Sujeet Chourasia (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 17:-</h6>
                <ul class="list-style list-style1">
                    <li>Khwaja Fazalullaha (Gold)</li>
                    <li>Amav Manohar Badge (Silver)</li>
                </ul>
            </div>
            <div class="col mt-4">
                <h6 class="fw-bold"> Indian Round Under 19:-</h6>
                <ul class="list-style list-style1">
                    <li>Aalok Sharma (Gold)</li>
                    <li>Ayush Moreshwar Khadse (Silver)</li>
                </ul>
            </div>
            <div class="col mt-4">
                <h6 class="fw-bold">Open</h6>
                <ul class="list-style list-style1">
                    <li>Anurag Sanjay Khedkar (Gold)</li>
                    <li>Kartik Narendra Mire (Silver)</li>
                    <li>Nitin Jadhav (Bronze)</li>
                </ul>
            </div>
        </div>
        <div class="sec-title text-center">
            <h4>Male <span >(Compound Round) </span></h4>
        </div>
        <div class="row row-cols-1 row-cols-md-4">

            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 11:-</h6>
                <ul class="list-style list-style1">
                    <li>Yathansh Pankaj Pillewar (Gold)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 14:-</h6>
                <ul class="list-style list-style1">
                    <li>Savma Parmod Wadskar (Gold)</li>
                    <li>Om Amol Mankar (Silver)</li>
                    <li>Vedant Vinod Lachhode (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 17:-</h6>
                <ul class="list-style list-style1">
                    <li>Antariksh vitthal gurav (Gold)</li>
                    <li>Yugant Pravin Maske (silver)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 19:-</h6>
                <ul class="list-style list-style1">
                    <li>Samyak Mohan Meshram (Gold)</li>
                    <li>Neel Sahilendra Hinge (Silver)</li>
                    <li>Soham Sandeep Kale (Bronze)</li>
                </ul>
            </div>
            <div class="col mt-4">
                <h6 class="fw-bold">Open :-</h6>
                <ul class="list-style list-style1">
                    <li>Harsh Goverdhan Mate (Gold)</li>
                    <li>Shalay Kishor Khadgi (Silver)</li>
                    <li>Avinash Kailash Handwate (Bronze)</li>
                </ul>
            </div>
        </div>

        <div class="sec-title text-center">
            <h4>Female <span > (Indian round) </span></h4>
        </div>
        <div class="row row-cols-1 row-cols-md-4">

            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 9:-</h6>
                <ul class="list-style list-style1">
                    <li>Ojasm Sontakke (Gold)</li>
                    <li>Swara Dhiraj Vithalkar (Silver)</li>
                    <li>Sameera Gabhane (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 11:-</h6>
                <ul class="list-style list-style1">
                    <li>Rupli Dinesh Dongre (Gold)</li>
                    <li>Aparna Nitin Gurve (Silver)</li>
                    <li>Sanskruit Deepak Goswami (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 14:-</h6>
                <ul class="list-style list-style1">
                    <li>Rashi Pralay Khaparde (Gold)</li>
                    <li>Tanvi Ganesh Madavi (Silver)</li>
                    <li>Akashra Chandrashekhar Gitte (Bronze)</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 17:-</h6>
                <ul class="list-style list-style1">
                    <li>Mishka Shivhare (Gold)</li>
                </ul>
            </div>
            <div class="col mt-4">
                <h6 class="fw-bold">Indian Round Under 19:-</h6>
                <ul class="list-style list-style1">
                    <li>Samiksha Sachin Nandeshwar (Gold)</li>
                    <li>Hasika Sachin Nandeshwar (Silver)</li>
                </ul>
            </div>
            <div class="col mt-4">
                <h6 class="fw-bold">Indian Round Open :-</h6>
                <ul class="list-style list-style1">
                    <li>Tina Sankar Menghar (Gold)</li>
                    <li>Priti Rahul Gajbhiye (Silver)</li>
                    <li>Ashwini Pahi (Bronze)</li>
                </ul>
            </div>
        </div>
        <hr>
        <div class="row row-cols-1 row-cols-md-2">

            <div class="col">

                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="/photogallery#ArcheryNagpur" class="cmn-white-button"><span>
                                    View More</span>
                            </a>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp7.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp7.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp7.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp8.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp8.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp8.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
